jQuery(document).ready(function ($) {
	$(".swiper-slide").on("click", () => {
		$(".slider-wrapper").slick("refresh");
	});

	const fractionFormatting = {
		type: "fraction",
		formatFractionCurrent: function (number) {
			return `0${number}`;
		},

		formatFractionTotal: function (number) {
			return `0${number}`;
		},

		renderFraction: function (currentClass, totalClass) {
			return `<span class="${currentClass}"></span>
              <span> / </span>
              <span class="${totalClass}"></span>`;
		},
	};

	const globalSliderValsDefault = {
		slidesPerView: 1,
		speed: 1000,
		allowTouchMove: true,
		spaceBetween: 15,
		centeredSlides: false,
	};

	$("#case_studies .slider-wrapper").slick({
		slidesToShow: 6,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 0,
		pauseOnHover: false,
		speed: 5000,
		cssEase: "linear",
		infinite: true,
		prevArrow: false,
		nextArrow: false,
		responsive: [
			{
				breakpoint: BOOTSTRAP_BREAKPOINTS.lg,
				settings: {
					draggable: true,
					slidesToShow: 3,
				},
			},
			{
				breakpoint: BOOTSTRAP_BREAKPOINTS.md,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	});

	$(".news-slider .slider-wrapper").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		variableWidth: true,
		prevArrow: $("#news_left"),
		nextArrow: $("#news_right"),
		draggable: false,
		focusOnSelect: true,
		accessibility: true,
		responsive: [
			{
				breakpoint: BOOTSTRAP_BREAKPOINTS.lg,
				settings: {
					prevArrow: $("#news_left_mobile"),
					nextArrow: $("#news_right_mobile"),
					draggable: true,
					touchThreshold: 500,
				},
			},
		],
	});

	$(".investments-slider .slider-wrapper").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		variableWidth: true,
		prevArrow: $("#investments_left"),
		nextArrow: $("#investments_right"),
		draggable: false,
		focusOnSelect: true,
		accessibility: true,
		responsive: [
			{
				breakpoint: BOOTSTRAP_BREAKPOINTS.lg,
				settings: {
					prevArrow: $("#investments_left_mobile"),
					nextArrow: $("#investments_right_mobile"),
					draggable: true,
					touchThreshold: 500,
				},
			},
		],
	});

	var swiper = new Swiper(".spotlight_swiper", {
		...globalSliderValsDefault,
		spaceBetween: 20,
		loop: true,
		autoplay: {
			delay: 5000,
			disableonInteraction: true,
		},

		navigation: {
			nextEl: "#next_investment",
			prevEl: "#prev_investment",
		},

		pagination: {
			el: ".spotlight_pagination",
			...fractionFormatting,
		},
	});

	const investmentSlides = document.querySelectorAll(
		".investments-slider .investments-article"
	);
	let currentSlide = 1;
	const maxSlidesToMoveAcross = investmentSlides.length - 2;
	$("#investments_right").on("click", () => {
		if (currentSlide < maxSlidesToMoveAcross) {
			currentSlide++;
		}
	});

	$("#investments_left").on("click", () => {
		if (currentSlide > 1) {
			currentSlide--;
		}
	});

	function checkSlide() {
		$("#investments_left").prop("disabled", currentSlide === 1);

		$("#investments_right").prop(
			"disabled",
			currentSlide === maxSlidesToMoveAcross
		);
	}
	checkSlide();

	$(".arrow-button").on("click", () => {
		checkSlide();
	});
});
